import { render, staticRenderFns } from "./SignerSelectionDialog.vue?vue&type=template&id=0fb33312&"
import script from "./SignerSelectionDialog.vue?vue&type=script&lang=js&"
export * from "./SignerSelectionDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports